// visibleExceptProd is no longer imported: with the scan gate closed nothing
// uses it, and CRA fails a CI build on an unused import. Both resume paths
// below need it back from './featureVisibility'.
import { devOnly } from './featureVisibility';

/**
 * Single switch for the photographed-report import review: the confirmation
 * screen the practitioner approves before a vision-read lab report becomes
 * values on the test.
 *
 * ON HOLD as of 2026-08-24 — dev only, hidden on slava and prod.
 *
 * It works end to end: the bloodworkVision Lambda is deployed and behind an
 * authenticated API, and the screen reads real reports. It is held back as a
 * product decision rather than a technical one, so the gate closes rather than
 * anything being torn down. Local dev keeps it so the work stays exercised.
 *
 * Fails closed without REACT_APP_VISION_LAMBDA_URL — see visionEnabled in
 * upload.tsx. A build that forgets the variable behaves exactly like today
 * rather than offering an import it cannot complete.
 *
 * Modeled on aiProgressSummaryVisible() and bwhLabsVisible(): a gate rather
 * than commented-out code, so the component, its types and the upload call site
 * keep compiling and cannot rot while the Lambda catches up.
 *
 * TO RESUME: return visibleExceptProd() for slava, or delete this function and
 * its call sites to ship everywhere. Nothing else needs changing. The read sits
 * behind a Lambda Function URL that accepts both the slava and prod Cognito
 * pools, and scripts/deploy.js ships that URL to every environment.
 */
export function importReviewVisible(): boolean {
  return devOnly();
}


/**
 * The narrower half of that feature: the "Scan for markers LabSmarts doesn't
 * have" button offered after a PDF has been parsed for free.
 *
 * Separate from importReviewVisible() because it is a separate decision. The
 * photographed-report import is on hold; this is not, because it is the only
 * way a marker LabSmarts has no field for can ever reach a test — the text
 * parser returns what it already knows and by construction cannot report the
 * rest.
 *
 * Held out of prod for now because it spends money per click, on a model call
 * per page. That is a decision to make deliberately rather than by shipping.
 *
 * Both gates read the same VISION_URL and the same onReviewImport in
 * upload.tsx, so either can be open without the other.
 *
 * CLOSED EVERYWHERE as of 2026-08-31, local dev included, at the practitioner's
 * request: the feature is not ready to ship and the button was visible on slava
 * while it sat behind visibleExceptProd(). Nothing is torn down, exactly as
 * with importReviewVisible() above — the button, the Lambda and the deep-scan
 * state all keep compiling.
 *
 * Worth knowing before reopening: this is still the only path by which a marker
 * LabSmarts has no field for can reach a test, so while it is closed a report's
 * unmapped rows are simply dropped with nothing offered in their place. The two
 * upload failure paths that used to offer it now fall through to their own
 * messages instead, which is why they read sensibly with the gate shut.
 *
 * TO RESUME: return visibleExceptProd() for slava and local, or devOnly() for
 * local only. Nothing else needs changing.
 */
export function unmappedMarkerScanVisible(): boolean {
  return false;
}
